import Vue from "vue";
import VueRouter from "vue-router";
import DashboardView from "../views/DashboardView.vue";
import LoginView from "../views/LoginView.vue";
import DownloadTestThroughEmail from "../views/downloadTestThroughEmail.vue";
import TestView from "../views/TestView.vue";
import InstructionsAboutTest from "../views/pages/studenttest/InstructionsAboutTest.vue";
import ExamSumary from "../views/pages/studenttest/ExamSumary.vue";
import Login from "../views/pages/auth/Login.vue";
import SignUp from "../views/pages/auth/SignUp.vue";
import SendOtp from "../views/pages/auth/SendOtp.vue";
import ChangePassword from "../views/pages/auth/ChangePassword.vue";
import SetPassword from "../views/pages/auth/SetPassword.vue";
import studentSignupStep2 from "../views/pages/auth/StudentSignupStep2.vue";
import StudentSignupStep3 from "../views/pages/auth/StudentSignupStep3.vue";
import ParentSignupStep2 from "../views/pages/auth/ParentSignupStep2.vue";
import TeacherSignupStep2 from "../views/pages/auth/TeacherSignupStep2.vue";
import CoordinatorSignupStep2 from "../views/pages/auth/CoordinatorSignupStep2.vue";

import Dashboard from "@/components/Dashboard/Dashboard.vue";
import Notification from "../views/pages/Notification.vue";
import ManageBatches from "../views/pages/Manage-Batches.vue";
import CreateBatch from "../views/pages/CreateBatch.vue";

import AddUser from "../views/pages/users/AddUser.vue";
import ApprovedUsers from "../views/pages/users/ApprovedUsers.vue";
import BatchAllocation from "../views/pages/users/BatchAllocation.vue";
import ManageUsers from "../views/pages/users/ManageUsers.vue";
import EditUsers from "../views/pages/users/EditUsers.vue";
import MonitorUsers from "../views/pages/users/MonitorUsers.vue";
import Profile from "../views/pages/Profile.vue";
import ComplimentaryTest from "../views/pages/Tests/ComplimentaryTest.vue";
import ScheduleTests from "../views/pages/Tests/ScheduleTests.vue";
import CreateCustomizedTest from "../views/pages/Tests/CreateCustomizedTest.vue";
import TestwiseAnalysis from "../views/pages/Tests/Testwise-Analysis.vue";
import PreviousTest from "../views/pages/Tests/PreviousTest.vue";
import CustomizedTest from "../views/pages/Tests/CustomizeTestTabs.vue";
import CustomizedTestMYT from "../views/pages/mytuser/MYTDashboard.vue";
import MyTests from "../components/CustomInstituteComponents/MyTests/MyTests.vue"
import MYTUploadImage from "../components/CustomInstituteComponents/MyTemplate/MYTUploadImage.vue"
import assignTests from "../views/pages/Tests/AssignTest.vue";
import PastTest from "../views/pages/Tests/PastTest.vue";
import ImprovementAssignments from "../views/pages/Tests/ImprovementAssignments.vue";
import ImprovementAssignmentsTestsList from "@/components/student/Tests/PastTests/ImprovementAssignmentsTestsList.vue";
import PastTestTeacher from "../views/pages/Tests/PastTestTeacher.vue";
import AllIndiaSeries from "../views/pages/Tests/AllIndiaSeries.vue";
import TestResults from "../views/pages/ResultAnalysis/TestResults.vue";
import Leaderboard from "../views/pages/Leaderboard/Leaderboard.vue";
import BatchHealth from "../views/pages/health/BatchHealth.vue";
import BatchHealthNew from "../views/pages/health/BatchHealthNew.vue";
import ResponseAnalysis from "../views/pages/ResultAnalysis/student/ResponseAnalysis.vue";
import CumulativeAnalysis from "../views/pages/ResultAnalysis/student/CumulativeAnalysis.vue";
import OnlineChapterStanding from "../views/pages/ResultAnalysis/student/OnlineChapterStanding.vue";
import TestReports from "../views/pages/ResultAnalysis/student/TestReports.vue";
import PracticeSessionReport from "../views/pages/ResultAnalysis/student/PracticeSessionReport.vue";
import AITSTestReports from "../views/pages/Tests/AITSTestReports.vue";
import PYTTestReports from "../views/pages/Tests/PYTTestReports.vue";
import PracticeTestReports from "../views/pages/Tests/PracticeTestReports.vue";
import MyHealth from "../views/pages/health/MyHealth.vue";
import ChaptersHealth from "../views/pages/health/ChaptersHealth.vue";
import StudentwiseHealth from "../views/pages/health/StudentwiseHealth.vue";
import TopicsPerChapterHealth from "../views/pages/health/TopicsPerChapterHealth.vue";
import UpgradeToGold from "../views/pages/UpgrateToGold/UpgradeToGold.vue";
import constants from "@/utils/constants.js";
import ReadyMadeTests from "../views/pages/Tests/ReadyMadeTests.vue";

import PreviewTest from "../views/pages/studenttest/PreviewTest.vue";
import PreviewMYTTest from "../views/pages/studenttest/PreviewMYTTest.vue";
import PreviewTestTeacher from "../views/pages/studenttest/PreviewTestTeacher.vue";
import PastTestDetails from "../views/pages/studenttest/PastTest.vue";
import PracticeSession from "../views/pages/studenttest/PracticeSession.vue";
import PracticeSessionQuestionView from "../views/pages/studenttest/PracticeSessionQuestionView.vue";

import store from "../store/drawerStore";
import userStore from "../store/userStore";
import menuList from "../utils/menu";
import TermsAndCOnditions from "../views/pages/TermsAndCOnditions.vue";
import PaymentTermsAndConditions from "../views/pages/PaymentTermsAndConditions.vue";
import ImageViewer from "../views/pages/ImageViewer.vue";
import PrivacyPolicy from "../views/pages/PrivacyPolicy.vue";
import RenewSubscription from "@/components/coordinator/subscription-details/RenewSubscription.vue";
import PurchaseSubscription from "@/components/coordinator/subscription-details/PurchaseSubscription.vue";
import Subscription from "../views/pages/Subscription/Subscription.vue";
import BookmarkedAttemptedQues from "../components/student/BoostUp/BookmarkedAttemptedQues.vue";
import BookmarkAttemptQidView from "../components/student/BoostUp/BookmarkAttemptQidView.vue";
import MySubscription from "@/components/student/UpgradeToGold/MySubscription.vue";
import ReadyMadeTestUpgrade from "@/components/student/UpgradeToGold/ReadyMadeTestUpgrade.vue";
import UnlockBoostUp from "@/components/student/UpgradeToGold/UnlockBoostUp.vue";

import MakeYourOwnTest from "../views/pages/Tests/MakeYourOwnTest.vue";
import CreateMakeYourOwnTest from "../views/pages/Tests/CreateMakeYourOwnTest.vue";
import StudentUpcomingTests from "@/components/student/Tests/UpcomingTests.vue";
import PastTestInstitute from "../views/pages/Tests/PastTestInstitute.vue";

import ExternalQuestionsList from "../views/pages/customization/ExtenalQuestionsList.vue";
import ExternalQuestionView from "../views/pages/customization/ExternalQuestionView.vue";
import AITSTest from "../views/pages/Tests/AITStests.vue";
import OnlineAITSTest from "../views/pages/Tests/OnlineAITStests.vue";
import OnlinePastTest from "../views/pages/Tests/OnlinePastTest.vue";

import { set, get } from "lodash";

import VueCookies from "vue-cookies";
import Onlinepyt from "../views/pages/Tests/Onlinepyt.vue";
Vue.use(VueCookies, { expire: "7d" });

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        meta: {
            name: "Login",
            requiresAuth: false,
        },
        component: Login,
    },
    {
        path: "*",
        component: Login,
    },
    {
        path: "/auth",
        name: "auth",
        component: LoginView,
        children: [
            {
                path: "login",
                name: "login",
                component: Login,
            },
            {
                path: "signup",
                name: "signup",
                component: SignUp,
            },
            {
                path: "student-signup-step2",
                name: "student-signup-step2",
                component: studentSignupStep2,
            },
            {
                path: "student-signup-step3",
                name: "student-signup-step3",
                component: StudentSignupStep3,
            },
            {
                path: "parent-signup-step2",
                name: "parent-signup-step2",
                component: ParentSignupStep2,
            },
            {
                path: "teacher-signup-step2",
                name: "teacher-signup-step2",
                component: TeacherSignupStep2,
            },
            {
                path: "coordinator-signup-step2",
                name: "coordinator-signup-step2",
                component: CoordinatorSignupStep2,
            },
            {
                path: "change-password",
                name: "change-password",
                component: ChangePassword,
            },
            {
                path: "forgot-password",
                name: "forgot-password",
                component: SendOtp,
            },
            {
                path: "new-password/:token",
                name: "new-password",
                component: SetPassword,
            },
            {
                path: "/terms-and-conditions",
                name: "terms-and-conditions",
                component: TermsAndCOnditions,
            },
             {
                path: "/download-test-through-email",
                name: 'download-test-through-email',
                component: DownloadTestThroughEmail,
            },
            {
                path: "/privacy-policy",
                name: "privacy-policy",
                component: PrivacyPolicy,
            },
            {
                path: "/payment-terms-and-conditions",
                name: "payment-terms-and-conditions",
                component: PaymentTermsAndConditions,
            },

            {
                path: "/image/:id",
                name: "image",
                component: ImageViewer,
            },
        ],
    },
    {
        path: "/dashboard",
        component: DashboardView,
        children: [
            {
                path: "home",
                name: "home",
                component: Dashboard,
            },
            {
                path: "notification-inbox",
                name: "notification-inbox",
                component: Notification,
            },
            {
                path: "notification-sent",
                name: "notification-sent",
                component: Notification,
            },
            {
                path: "notification-trash",
                name: "notification-trash",
                component: Notification,
            },
            {
                path: "manage-batches",
                name: "manage-batches",
                component: ManageBatches,
            },
            {
                path: "create-batch",
                name: "create-batch",
                component: CreateBatch,
            },
            {
                path: "add-users",
                name: "add-users",
                component: AddUser,
            },
            {
                path: "approve-users",
                name: "approve-users",
                component: ApprovedUsers,
            },
            {
                path: "batch-allocation",
                name: "batch-allocation",
                component: BatchAllocation,
            },
            {
                path: "manage-users",
                name: "manage-users",
                component: ManageUsers,
            },
            {
                path: "edit-users",
                name: "edit-users",
                component: EditUsers,
            },
            {
                path: "monitor-students",
                name: "monitor-students",
                component: MonitorUsers,
            },
            {
                path: "students-anaylsis",
                name: "students-anaylsis",
                component: MonitorUsers,
            },
            {
                path: "profile",
                name: "profile",
                component: Profile,
            },
            {
                path: "complimentary-test",
                name: "complimentary-test",
                component: ComplimentaryTest,
            },
            {
                path: "schedule-tests",
                name: "schedule-tests",
                component: ScheduleTests,
            },
            {
                path: "customized-tests",
                name: "customized-tests",
                component: CustomizedTest,
            },
            {
                path: "customized-tests-myt",
                name: "customized-tests-myt",
                component: CustomizedTestMYT,
            },
            {
                path: "create-customized-tests",
                name: "create-customized-tests",
                component: CreateCustomizedTest,
            },
            {
                path: "all-india-test-series",
                name: "all-india-test-series",
                component: AllIndiaSeries,
            },
             {
                path: "aits-test",
                name: "aits-test",
                component: AITSTest,
            },
            {
                path: "online-aits-test",
                name: "online-aits-test",
                component: OnlineAITSTest,
            },
            {
                path: "test-results",
                name: "test-results",
                component: TestResults,
            },
            {
                path: "studentwise-health",
                name: "studentwise-health",
                component: StudentwiseHealth,
            },
            {
                path: "batch-health",
                name: "batch-health",
                component: BatchHealthNew,
            },
            {
                path: "batch-health-old",
                name: "batch-health-old",
                component: BatchHealth,
            },
            {
                path: "my-health",
                name: "my-health",
                component: MyHealth,
            },
            {
                path: "student-health",
                name: "student-health",
                component: MyHealth,
            },
            {
                path: "chapters-health/:subject_name/:subject_id/:student_id",
                name: "chapters-health",
                component: ChaptersHealth,
                props: true,
            },
            {
                path: "student-health1",
                name: "student-health1",
                component: ChaptersHealth,
            },
            {
                path: "topic-health/:subject/:subject_id/:chapter_id/:student_id",
                name: "topic-health",
                component: TopicsPerChapterHealth,
            },
            {
                path: "leaderboard",
                name: "leaderboard",
                component: Leaderboard,
            },
            {
                path: "bookmarked-questions",
                name: "bookmarked-questions",
                component: BookmarkedAttemptedQues,
            },
            {
                path: "ready-made-test",
                name: "ready-made-test",
                component: PreviousTest,
            },
            {
                path: "pyt-test",
                name: "pyt-test",
                component: Onlinepyt,
            },
            {
                path: "past-test",
                name: "past-test",
                component: PastTest,
            },
            {
                path: "online-past-test",
                name: "online-past-test",
                component: OnlinePastTest,
            },
            {
                path: "practice-session",
                name: "practice-session",
                component: PracticeSession,
            },
            {
                path: "premium-test",
                name: "premium-test",
                component: PreviousTest,
            },
            {
                path: "attempted-questions",
                name: "attempted-questions",
                component: BookmarkedAttemptedQues,
            },
            // {
            //     path: "premium-test",
            //     name: "premium-test",
            //     component: PreviousTest,
            // },
            {
                path: "testwise-analysis",
                name: "testwise-analysis",
                component: TestwiseAnalysis,
                props: true,
            },
            {
                path: "testwise-analysis/:type/:name/:student_id/:batch_id",
                name: "testwise-analysis-coordinator",
                component: TestwiseAnalysis,
                props: true,
            },
            {
                path: "testwise-analysis/:type/:name/:student_id/:batch_id",
                name: "testwise-analysis-director",
                component: TestwiseAnalysis,
                props: true,
            },
            {
                path: "myt-test-analysis",
                name: "myt-test-analysis",
                component: () => import("../views/pages/Tests/MYTTestAnalysis.vue"),
                props: true,
            },
            {
                path: "myt-test-analysis/:student_id/:batch_id",
                name: "myt-test-analysis-coordinator",
                component: () => import("../views/pages/Tests/MYTTestAnalysis.vue"),
                props: true,
            },
            {
                path: "myt-test-analysis/:student_id/:batch_id",
                name: "myt-test-analysis-director",
                component: () => import("../views/pages/Tests/MYTTestAnalysis.vue"),
                props: true,
            },
            {
                path: "pyt-test-analysis",
                name: "pyt-test-analysis",
                component: () => import("../views/pages/Tests/PYTTestAnalysis.vue"),
                props: true,
            },
            {
                path: "pyt-test-analysis/:student_id/:batch_id",
                name: "pyt-test-analysis-coordinator",
                component: () => import("../views/pages/Tests/PYTTestAnalysis.vue"),
                props: true,
            },
            {
                path: "pyt-test-analysis/:student_id/:batch_id",
                name: "pyt-test-analysis-director",
                component: () => import("../views/pages/Tests/PYTTestAnalysis.vue"),
                props: true,
            },
            {
                path: "aits-test-analysis",
                name: "aits-test-analysis",
                component: () => import("../views/pages/Tests/AITSTestAnalysis.vue"),
                props: true,
            },
            {
                path: "aits-test-analysis/:student_id/:batch_id",
                name: "aits-test-analysis-coordinator",
                component: () => import("../views/pages/Tests/AITSTestAnalysis.vue"),
                props: true,
            },
            {
                path: "aits-test-analysis/:student_id/:batch_id",
                name: "aits-test-analysis-director",
                component: () => import("../views/pages/Tests/AITSTestAnalysis.vue"),
                props: true,
            },
            {
                path: "cumulative-analysis/:type/:student_id/:batch_id",
                name: "cumulative-analysis-coordinator",
                component: CumulativeAnalysis,
                props: true,
            },
            {
                path: "cumulative-analysis/:type/:student_id/:batch_id",
                name: "cumulative-analysis-director",
                component: CumulativeAnalysis,
                props: true,
            },
            {
                path:
                    "analysis/:test_name/:test_institute_id/:student_test_id/:batch_id/:test_id/:student_id/:selectedTestType",
                name: "response-analysis-coordinator",
                component: ResponseAnalysis,
            },
            {
                path:
                    "analysis/:test_name/:test_institute_id/:student_test_id/:batch_id/:test_id/:student_id",
                name: "response-analysis-director",
                component: ResponseAnalysis,
            },
            {
                path:
                    "analysis/:test_name/:test_institute_id/:student_test_id/:batch_id/:test_id/:student_id",
                name: "response-analysis-practice",
                component: ResponseAnalysis,
            },
            {
                path:
                    "pyt-online-analysis/:test_name/:test_institute_id/:student_test_id/:batch_id/:test_id/:student_id/:result_type",
                name: "pyt-response-analysis-online",
                component: ResponseAnalysis,
            },
            {
                path:
                    "aits-online-analysis/:test_name/:test_institute_id/:student_test_id/:batch_id/:test_id/:student_id/:result_type",
                name: "aits-response-analysis-online",
                component: ResponseAnalysis,
            },
            {
                path:
                    "myt-online-analysis/:test_name/:test_institute_id/:student_test_id/:batch_id/:test_id/:student_id/:result_type",
                name: "myt-response-analysis-online",
                component: ResponseAnalysis,
            },
            {
                path: "cumulative-analysis",
                name: "cumulative-analysis",
                component: CumulativeAnalysis,
            },
            {
                path: "online-chapter-standing",
                name: "online-chapter-standing",
                component: OnlineChapterStanding,
            },
            {
                path: "test-reports",
                name: "test-reports",
                component: TestReports,
            },
            {
                path: "aits-test-reports",
                name: "aits-test-reports",
                component: AITSTestReports,
            },
            {
                path: "pyt-test-reports",
                name: "pyt-test-reports",
                component: PYTTestReports,
            },
            {
                path: "practice-test-reports",
                name: "practice-test-reports",
                component: PracticeTestReports,
            },
            {
                path: "my-subscription",
                name: "my-subscription",
                component: UpgradeToGold,
            },
            {
                path: "boost-up-upgrade",
                name: "boost-up-upgrade",
                component: UpgradeToGold,
            },
            {
                path: "readymade-test-upgrade",
                name: "readymade-test-upgrade",
                component: UpgradeToGold,
            },
            {
                path: "masterpyq-upgrade",
                name: "masterpyq-upgrade",
                component: () => import("../views/pages/UpgrateToGold/UpgradeToGold.vue"),
            },
            {
                path: "subscription-details",
                name: "subscription-details",
                component: Subscription,
            },
            {
                path: "renew-subscription",
                name: "renew-subscription",
                component: RenewSubscription,
            },
            {
                path: "purchase-subscription",
                name: "purchase-subscription",
                component: PurchaseSubscription,
            },
            {
                path: "assign-tests",
                name: "assign-tests",
                component: assignTests,
            },
            {
                path: "past-tests",
                name: "past-tests-teacher",
                component: PastTestTeacher,
            },
            {
                path: "make-your-test",
                name: "make-your-test",
                component: MakeYourOwnTest,
            },
            {
                path: "improvement-assignments",
                name: "improvement-assignments",
                component: ImprovementAssignments,
            },
            {
                path: "create-MYT-tests",
                name: "create-MYT-tests",
                component: CreateMakeYourOwnTest,
            },
            {
                path: "practice-report",
                name: "practice-report",
                component: PracticeSessionReport,
            },
            {
                path: "my-tests",
                name: "my-tests",
                component: MyTests,
            },            {
                path: "my-template",
                name: "my-template",
                component: MYTUploadImage,
            },
            {
                path: "past-test-institute",
                name: "past-test-institute",
                component: PastTestInstitute,
            },

            {
                path: "live-test",
                name: "live-test",
                component: StudentUpcomingTests,
            },

            {
                path: "upcoming-test",
                name: "upcoming-test",
                component: StudentUpcomingTests,
            },
            {
                path: "personal-questions",
                name: "personal-questions",
                component: ExternalQuestionsList,
            },
            {
                path: "bookmark-questions",
                name: "bookmark-questions",
                component: ExternalQuestionsList,
            },
            {
                path: "attendance-list",
                name: "attendance-list",
                component: () => import("../views/pages/AttendanceList.vue"),
            },
            {
                path: "mark-attendance",
                name: "mark-attendance",
                component: () => import("../views/pages/MarkAttendance.vue"),
            },
            {
                path: "timetable-list",
                name: "timetable-list",
                component: () => import("../views/pages/TimetableList.vue"),
            },
        ],
    },
    {
        path: "/test",
        component: TestView,
        children: [
            {
                path: "instructions-about-test/:test_institute_id/:test_id",
                name: "instructions-about-test",
                component: InstructionsAboutTest,
            },
            {
                path: "exam-summary",
                name: "exam-summary",
                component: ExamSumary,
            },
            {
                path: "preview-test/:test_id/:test_institute_id",
                name: "result-anaylysis-preview-test",
                component: PreviewTest,
            },
            {
                path: "preview-test/:test_id/:test_institute_id",
                name: "preview-test",
                component: PreviewTest,
            },
            {
                path: "live-test/:test_id/:test_institute_id/:test_schedule_id/:student_id",
                name: "test",
                component: PreviewTest,
            },
            {
                path: "past-test/:test_id/:test_institute_id",
                name: "past-test-details",
                component: PastTestDetails,
            },
            {
                path: "past-tests-preview/:test_id/:test_institute_id",
                name: "past-tests-preview",
                component: PreviewTestTeacher,
            },
            {
                path:
                    "practice-session-question-view/:practice_session_id/:subject_id/:test_id/:topicsSelected",
                name: "practice-session-question-view",
                component: PracticeSessionQuestionView,
            },
            {
                path:
                    "improvement-assignment-question-view/:improvement_assign_id/:student_id",
                name: "improvement-assignment-question-view",
                component: PracticeSessionQuestionView,
            },
            {
                path:
                    "bookmarked-question-details/:requiredCall/:test_detail_id/:index/:pageNumber",
                name: "bookmarked-question-details",
                component: BookmarkAttemptQidView,
            },
            {
                path: "preview-myt-test/:test_id/:test_institute_id",
                name: "preview-myt-test",
                component: PreviewMYTTest,
            },
            {
                path: "question-details/:requiredCall",
                name: "question-details",
                component: ExternalQuestionView,
            },
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

window.popStateDetected = false;
window.addEventListener("popstate", () => {
    window.popStateDetected = true;
});
const routesArray = []
router.beforeEach((to, from, next) => {
    let institute = JSON.parse(localStorage.getItem("myInstitute"));
    let IsItABackButton = window.popStateDetected;
    if (
        from.name == "practice-session-question-view" &&
        (IsItABackButton || to.name == "practice-session-question-view")
    ) {
        window.popStateDetected = false;
        next(false);
        return;
    }
    let routeInfo = sessionStorage.getItem("routeInfo");
    routeInfo = routeInfo ? JSON.parse(routeInfo) : null;
    let pathName = window.location.pathname;
    if (
        routeInfo &&
        routeInfo.testFinished &&
        to.name == "exam-summary" &&
        (from.name == "schedule-tests" || pathName == "dashboard/schedule-tests")
    ) {
        next(false);
        return;
    } else if (routeInfo && routeInfo.testFinished && to.name == "exam-summary") {
        return router
            .push("/dashboard/schedule-tests")
            .catch((err) => console.error(err));
    }

    if (
        (userStore.state && userStore.state.user) ||
        (institute && constants.CUSTOM_INSTITUTE_ID.includes(institute.id))
    ) {
        let userRoleID = userStore?.state?.user?.role_id;
        let menuListArray = [];
        if (
            institute &&
            constants.CUSTOM_INSTITUTE_ID.includes(institute.id)
        ) {
            menuListArray = menuList.MENU.CUSTOMMENU;
        }else if (
            constants.ROLES_ID.CO === userRoleID ||
            constants.ROLES_ID.ID === userRoleID
        ) {
            menuListArray = menuList.MENU.COORDINATOR;
        } else if (constants.ROLES_ID.ST === userRoleID) {
            const instituteDetails = JSON.parse(localStorage.getItem("myInstitute"));
            if (
                instituteDetails &&
                instituteDetails.id === constants.ONLINE_INSTITUTE_ID
            ) {
                menuListArray = menuList.MENU.ONLINESTUDENT;
            } else {
                menuListArray = menuList.MENU.STUDENT;
            }
        } else if (constants.ROLES_ID.PA === userRoleID) {
            menuListArray = menuList.MENU.PARENT;
        } else if (constants.ROLES_ID.ED === userRoleID) {
            menuListArray = menuList.MENU.DEO;
        } else if (constants.ROLES_ID.TR === userRoleID) {
            menuListArray = menuList.MENU.TEACHER;
        }  
        let selectedMenu = menuListArray.filter((m) => m.toRoute === to.name);
        if (!selectedMenu || selectedMenu.length < 1) {
            //check inside submenul
            menuListArray.map((x) => {
                let tmp = x.sub_menus.filter((m) => m.toRoute === to.name);
                if (tmp && tmp.length) {
                    store.mutations.onMenuSelected(store.state, {
                        main: x,
                        sub: tmp[0],
                    });
                    return;
                } else if (x.sub_menus) {
                    //Check sub menus sub pages
                    x.sub_menus.map((subMnu) => {
                        if (subMnu.sub_pages) {
                            let tmp = subMnu.sub_pages.filter((m) => m === to.name);
                            if (tmp && tmp.length) {
                                store.mutations.onMenuSelected(store.state, {
                                    main: x,
                                    sub: subMnu,
                                });
                            }
                        }
                    });
                }
            });
        } else if (selectedMenu && selectedMenu.length) {
            store.mutations.onMenuSelected(store.state, {
                main: selectedMenu[0],
                sub: selectedMenu[0].sub_menus[0],
            });
        }
    }

    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = [
        "terms-and-conditions",
        "privacy-policy",
        "login",
        "forgot-password",
        "signup",
        "change-password",
        "new-password",
        "student-signup-step2",
        "student-signup-step3",
        "parent-signup-step2",
        "teacher-signup-step2",
        "coordinator-signup-step2",
        "payment-terms-and-conditions",
        "customized-tests-myt",
        "my-tests",
        "my-template",
        "preview-myt-test",
        "image",
        "download-test-through-email"
    ];
    let CustomRoutes=["customized-tests-myt",
    "my-tests",
    "my-template",
    "preview-myt-test"]
    let onlineSignUpRoute = ["signup","forgot-password"];
    let userCookie = VueCookies.get("userDetails");
    if (userCookie && userCookie.userToken && userCookie.user) {
        sessionStorage.setItem("user", JSON.stringify(userCookie.user));
        localStorage.setItem("user", JSON.stringify(userCookie.user));
        sessionStorage.setItem("auth_token", JSON.parse(userCookie.userToken));
        localStorage.setItem("auth_token", JSON.parse(userCookie.userToken));
    }
    const requiresAuth = !publicPages.includes(to.name);
    const loggedIn = sessionStorage.getItem("auth_token");
    if (requiresAuth && !loggedIn) {
        
        // TODO store attempted page to route to later after successful login
        if (to.name) {
            sessionStorage.setItem("redirectAfterLogin", to.name);
        }

            try {
                return next("/auth/login");
              } catch (err) {
                console.error(err);
              }
    }
    // if the user is redirecting to excluded route then redirecting the user to home

    const excludeRoutes = JSON.parse(sessionStorage.getItem("excludeRoute"));
    if (loggedIn && institute &&
        !constants.CUSTOM_INSTITUTE_ID.includes(institute.id) &&
        excludeRoutes &&
        excludeRoutes.length &&
        !excludeRoutes.includes(to.name) && !routesArray.includes(to.name)
        ) {
            routesArray.push(to.name)
            return next("/dashboard/home");
        }
        const instituteDetails = JSON.parse(localStorage.getItem("myInstitute"));
        if (
            instituteDetails &&
            instituteDetails.id === constants.ONLINE_INSTITUTE_ID &&
            onlineSignUpRoute.includes(to.name)
        ) {
            return next("/auth/login");
        }
        if (institute && constants.CUSTOM_INSTITUTE_ID.includes(institute.id) && !CustomRoutes.includes(to.name)) {
            try {
                return next('/dashboard/customized-tests-myt')
            } catch (error) {
                console.log(error);
            }
        }
        setTimeout(()=>{
            routesArray.pop()
        },500)
        if (CustomRoutes.includes(to.name) && institute && !constants.CUSTOM_INSTITUTE_ID.includes(institute.id)) {
            return next("/auth/login");
        }
            next();
});
export default router;
